module.exports = __webpack_public_path__ + "img/医保.c5a474f8.png";